export default __webpack_public_path__ + "static/media/profile-2.2dcee33e.svg";